// create callReportSlice.js for managing call report filters
import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_CALL_AVG_DURATION_FILTER } from "../../constant/ReportConstants";

const initialState = {
  filters: {
    search: "",
    department: null,
    dateRange: [null, null],
    inboundAverageCallDuration: DEFAULT_CALL_AVG_DURATION_FILTER,
    outboundAverageCallDuration: DEFAULT_CALL_AVG_DURATION_FILTER,
  },
};

const callReportSlice = createSlice({
  name: "callReport",
  initialState,
  reducers: {
    setSearchFilter: (state, action) => {
      state.filters.search = action.payload;
    },
    setDepartmentFilter: (state, action) => {
      state.filters.department = action.payload;
    },
    setDateRangeFilter: (state, action) => {
      state.filters.dateRange = action.payload;
    },
    setAverageCallDurationFilter: (state, action) => {
      state.filters.inboundAverageCallDuration = action.payload.inboundAverageCallDuration;
      state.filters.outboundAverageCallDuration = action.payload.outboundAverageCallDuration;
    },
    resetFilters: state => {
      state.filters = initialState.filters;
    },
  },
});

export const {
  setSearchFilter,
  setDepartmentFilter,
  setDateRangeFilter,
  resetFilters,
  setAverageCallDurationFilter,
} = callReportSlice.actions;

export default callReportSlice.reducer;
